module.exports = __webpack_public_path__ + "img/logo.c392b581.svg";